import { Box, Grid, useTheme } from '@mui/material'
import PageHeader from '../../../components/PageHeader'
import { faHome, faTasks } from '@fortawesome/free-solid-svg-icons'
import './Dashboard.css'
import DashboardCard from './cards/DashboardCard'
import medicationsIcon from '../../../icons/refill_gray.svg'
import aedIcon from '../../../icons/AEDicon.svg'
import bioIcon from '../../../icons/infection_control.svg'
import sharpsIcon from '../../../icons/Sharps_2.svg'
import pharmaIcon from '../../../icons/unused_meds_1.svg'
import amalagmIcon from '../../../icons/Amalgam_2.svg'
import waterlineIcon from '../../../icons/waterline_icon.svg'
import oshaHipaaIcon from '../../../icons/osha_hipaa.svg'
import trainingIcon from '../../../icons/graduation-cap-solid.svg'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { useEffect } from 'react'
import { clearDashboardCustomer, getDashboardData, selectCustomerNumber } from './slice'
import Medications from './cards/Medications'
import AEDsAndDevices from './cards/AEDsAndDevices'
import BiologicalMonitoring from './cards/BiologicalMonitoring'
import MedicalWaste from './cards/MedicalWaste'
import PharmaWaste from './cards/PharmaWaste'
import AmalgamWaste from './cards/AmalgamWaste'
import Waterline from './cards/Waterline'
import Tasks from './cards/Tasks'
import OshaHipaa from './cards/OshaHipaa'
import Training from './cards/Training'
import Alerts from './Alerts'
import { selectLoadingState } from './slice'
import LoadingScreen from '../../../components/LoadingScreen'
import { DashBoardCard, LoadingState } from '../../../types'
import useIsCorpView from '../../../hooks/useIsCorpView'
import useCustomer from '../../../hooks/useCustomer'

const cards: DashBoardCard[] = [
  {
    title: 'Medications',
    icon: medicationsIcon,
    link: '/medications',
    content: Medications
  },
  {
    title: 'AEDs & Devices',
    icon: aedIcon,
    link: '/devices',
    content: AEDsAndDevices
  },
  {
    title: 'Biological Monitoring',
    icon: bioIcon,
    link: '/biological',
    content: BiologicalMonitoring
  },
  {
    title: 'Sharps & Medical Waste',
    icon: sharpsIcon,
    link: '/medical-waste',
    content: MedicalWaste
  },
  {
    title: 'Pharmaceutical Waste',
    icon: pharmaIcon,
    link: '/pharmaceutical-waste',
    content: PharmaWaste,
  },
  {
    title: 'Amalgam Waste',
    icon: amalagmIcon,
    link: '/amalgam-waste',
    content: AmalgamWaste,
  },
  {
    title: 'Waterline Management',
    icon: waterlineIcon,
    link: '/waterline-management',
    content: Waterline,
  },
  {
    title: 'Tasks',
    icon: faTasks,
    link: '/tasks',
    content: Tasks
  },
  {
    title: 'OSHA/HIPAA',
    icon: oshaHipaaIcon,
    link: '/osha-hipaa',
    content: OshaHipaa
  },
  {
    title: 'Training',
    icon: trainingIcon,
    link: '/training',
    content: Training
  }
]

const Dashboard = () => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  
  const customer = useCustomer()
  const isCorporate = useIsCorpView()

  const loadingState = useAppSelector(selectLoadingState)
  const dashboardCustomer = useAppSelector(selectCustomerNumber)

  const isDataLoaded = customer && customer.customerMetadata && dashboardCustomer && loadingState === LoadingState.Done

  useEffect(() => {
    const needsData = Boolean(customer.customer_number) && !dashboardCustomer && loadingState === LoadingState.NotStarted
    const clearData = Boolean(customer.customer_number) && dashboardCustomer && dashboardCustomer !== customer.customer_number

    if (needsData) {
      dispatch(getDashboardData(customer.customer_number))
    } else if (clearData) {
      dispatch(clearDashboardCustomer())
    }
  }, [dashboardCustomer, customer.customer_number, loadingState])

  return isDataLoaded ? (
    <Box className='dashboard-container' sx={{ backgroundColor: theme.palette.background.default }}>
      <PageHeader headerName='Dashboard' size='26px' iconName={faHome} />
      <Box sx={{ color: theme.palette.color50555b.main, padding: '15px' }}>
        <Alerts />
        <Grid container columnSpacing={2}>
          {cards.map((card) => (
            <Grid item key={card.title} sm={12} md={12} lg={6} xl={4} display="flex" justifyContent="center" alignItems="center">
              <DashboardCard
                card={card}
                isCorporate={isCorporate}
                customerNumber={customer.customer_number}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  ) : <LoadingScreen />
}

export default Dashboard